import * as React from 'react';
import { MenuItem, TextField } from '@mui/material';
import { Field } from 'redux-form';
import { useIntl } from 'react-intl';
import { renderInput } from '../../../components/forms/Fields';
import { Role } from '../../../types/administrationTypes';

interface UserDataConfigurationProps {
  userSelectedMainRole: string;
  mainRoles: Role[];
  handleMainRoleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const UserDataConfiguration: React.FC<UserDataConfigurationProps> = ({
  userSelectedMainRole,
  mainRoles,
  handleMainRoleChange,
}) => {
  const intl = useIntl();

  return (
    <>
      <div className="tff-administration-user-data-row">
        <div className="tff-administration-user-data-input">
          <TextField
            label={`${intl.formatMessage({ id: 'administration.role' })}`}
            placeholder="Select a role"
            variant="filled"
            InputProps={{
              className: 'tff-administration-input-style-color',
            }}
            fullWidth
            value={userSelectedMainRole}
            select
            onChange={handleMainRoleChange}
          >
            {mainRoles?.map((role, index) => (
              <MenuItem key={index} value={role.id}>
                {role.description}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className="tff-administration-user-data-input">
          <Field
            name="email"
            label={`${intl.formatMessage({ id: 'administration.email' })}`}
            variant="filled"
            InputProps={{
              className: 'tff-administration-input-style-color',
            }}
            InputLabelProps={{ shrink: true }}
            fullWidth
            disabled
            component={renderInput}
          />
        </div>
      </div>
      <div className="tff-administration-user-data-row">
        <div className="tff-administration-user-data-input">
          <Field
            name="firstName"
            label={`${intl.formatMessage({ id: 'administration.firstName' })}`}
            variant="filled"
            InputProps={{
              className: 'tff-administration-input-style-color',
            }}
            InputLabelProps={{ shrink: true }}
            fullWidth
            disabled
            component={renderInput}
          />
        </div>
        <div className="tff-administration-user-data-input">
          <Field
            name="lastName"
            label={`${intl.formatMessage({ id: 'administration.lastName' })}`}
            variant="filled"
            InputProps={{
              className: 'tff-administration-input-style-color',
            }}
            InputLabelProps={{ shrink: true }}
            fullWidth
            disabled
            component={renderInput}
          />
        </div>
      </div>
    </>
  );
};

export default UserDataConfiguration;
